<template>
    <div class="cluster-marker">
        <div class="outer-top">
            <div class="number-container left">
                <div class="number status-normal">{{severityTotals[0]}}</div>
            </div>
            <div class="number-container middle">
                <div class="number status-info">{{severityTotals[1]}}</div>
            </div>
            <div class="number-container right">
                <div class="number status-warning">{{severityTotals[2]}}</div>
            </div>
        </div>
        <span class="inner-text">{{totalMarkers}}</span>
        <div class="outer-bottom">
            <div class="number-container left">
                <div class="number status-minor">{{severityTotals[3]}}</div>
            </div>
            <div class="number-container middle">
                <div class="number status-major">{{severityTotals[4]}}</div>
            </div>
            <div class="number-container right">
                <div class="number status-critical">{{severityTotals[5]}}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'ClusterMarker',
  props: {
    severityTotals: Array,
    totalMarkers: Number
  }
}
</script>

<style scoped>
.cluster-marker {
    width: 4em;
    height: 5em;
    background-color: white;
    border-radius: 6em;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    font-size: 1em;
    font-family: sans-serif;
}

.cluster-marker:hover {
    opacity: 0.5;
}

.cluster-marker .inner-text {
    text-align: center;
    font-size: 1.1em;
    font-weight: bold;
    transform: translateY(5%);
    padding: 0.3em;
    background-color: white;
    border-radius: 1em;
    flex-shrink: 0;
}

.cluster-marker .outer-top,
.cluster-marker .outer-bottom {
    display: flex;
    height: 2em;
    justify-content: center;
    gap: 0.1em;
    z-index: 2;
}

.cluster-marker .outer-top {
    align-items: flex-start;
}

.cluster-marker .outer-bottom {
    align-items: flex-end;
}

.cluster-marker .number-container {
    display: flex;
    flex-shrink: 0;
}

.cluster-marker .number-container.left {
    justify-content: flex-end;
}

.cluster-marker .number-container.left,
.cluster-marker .number-container.right {
    width: 6em;
}

.cluster-marker .number-container.middle {
    min-width: 2em;
    justify-content: center;
}

.cluster-marker .number {
    border-radius: 1em;
    height: 1.2em;
    line-height: 1.1em;
    padding: 0 0.3em 0.15em;
    border: 1px solid rgba(0, 0, 0, 0.7);
}

.cluster-marker .outer-top .number {
    transform: translateY(25%);
}

.cluster-marker .outer-top .middle {
    transform: translateY(-50%);
}

.cluster-marker .outer-bottom .number {
    transform: translateY(-25%);
}

.cluster-marker .outer-bottom .middle {
    transform: translateY(50%);
}

.cluster-marker .number.status-normal {
    background-color: var(--col-normal);
}

.cluster-marker .number.status-info {
    background-color: var(--col-info);
}

.cluster-marker .number.status-warning {
    background-color: var(--col-warning);
}

.cluster-marker .number.status-minor {
    background-color: var(--col-minor);
}

.cluster-marker .number.status-major {
    background-color: var(--col-major);
}

.cluster-marker .number.status-critical {
    background-color: var(--col-critical);
}
</style>
